export const usedFunction = () => {
    console.log('This function is used');
  };
  
  export const unusedFunction = () => {
    console.log('This function is unused');
  };
  